import axiosInstance from "auth/FetchInterceptor";
import {
  MOBILE_PRODUCT_DETAIL,
  PRODUCT_API,
  PRODUCT_CHANGE_STATE,
  PRODUCT_SEARCH_GRID, PRODUCT_UPDATE_VARIANT, PRODUCT_WAREHOUSE, PRODUCTS_CHANGE_STATUS,
  PRODUCTS_COPY, PRODUCTS_DISCOUNT,
  PRODUCTS_GROUP_CATEGORY,
  PRODUCT_DELETE_MULTI,
  PRODUCT_WAREHOUSE_V2,
  PARTNER_UNIT,
  PRODUCT_SEARCH_GRID_V2,
  PRODUCT_WAREHOUSE_SEARCH_GRID_V2,
  PRODUCT_UPDATE_VARIANT_V2,
  SYNC_PRODUCT_PARTNER,
  PRODUCTS_GROUP_CATEGORY_V2,
  APPLY_OTHER_OPTION,
  APPLY_ADDITION_OPTION,
  PRODUCT_WAREHOUSE_SELECT_LIST,
} from "constants/ApiConstant";
const ProductService = {};

ProductService.productSearchGrid = function (data) {
  return axiosInstance.post(PRODUCT_SEARCH_GRID, data);
};

ProductService.getProductById = function (id) {
  return axiosInstance.get(`${PRODUCT_API}/${id}`, null);
};
ProductService.getProductMobileById = function (id) {
  return axiosInstance.get(`${MOBILE_PRODUCT_DETAIL}/${id}`, null);
};
ProductService.addProduct = function (data) {
  return axiosInstance.post(`${PRODUCT_API}/v2`, data);
};
ProductService.updateProduct = function (data) {
  return axiosInstance.put(`${PRODUCT_API}/v2`, data);
};
ProductService.updateProductState = function (data) {
  return axiosInstance.put(PRODUCT_CHANGE_STATE, data);
};
ProductService.delProduct = function (id) {
  return axiosInstance.delete(`${PRODUCT_API}/id?id=${id}`, null);
};
ProductService.copyProducts = function (data) {
  return axiosInstance.post(PRODUCTS_COPY, data);
};

ProductService.groupCategory = function (data) {
  return axiosInstance.post(PRODUCTS_GROUP_CATEGORY, data);
};

ProductService.groupCategoryV2 = function (data) {
  return axiosInstance.post(PRODUCTS_GROUP_CATEGORY_V2, data);
};

ProductService.changeStatusProducts = function (data) {
  return axiosInstance.put(PRODUCTS_CHANGE_STATUS, data);
};

ProductService.discountProducts = function (data) {
  return axiosInstance.put(PRODUCTS_DISCOUNT, data);
};

ProductService.updateVariant = function (data) {
  return axiosInstance.put(PRODUCT_UPDATE_VARIANT, data);
}

ProductService.getProductWarehouseList = function (data) {
  return axiosInstance.post(PRODUCT_WAREHOUSE_V2, data);
}

ProductService.getAllProductWarehouse = function (data) {
  return axiosInstance.post(PRODUCT_WAREHOUSE, data);
}
ProductService.delMultiProducts = function (data) {
  return axiosInstance.delete(PRODUCT_DELETE_MULTI, { data });
};

//PRODUCT V2/V3
ProductService.productSearchGridV2 = function (data) {
  return axiosInstance.post(PRODUCT_SEARCH_GRID_V2, data);
};
ProductService.warehouseProductSearchGrid = function (data) {
  return axiosInstance.post(PRODUCT_WAREHOUSE_SELECT_LIST, data);
};  //PRODUCT WAREHOUSE (KHÔNG CÓ PHÂN TRANG ==> SELECT LIST)
ProductService.warehouseProductSearchGridV2 = function (data) {
  return axiosInstance.post(PRODUCT_WAREHOUSE_SEARCH_GRID_V2, data);
};  //PRODUCT WAREHOUSE (CÓ PHÂN TRANG)

ProductService.getProductByIdV2 = function (id) {
  return axiosInstance.get(`${PRODUCT_API}/v2/${id}`, null);
};

ProductService.addProductV3 = function (data) {
  return axiosInstance.post(`${PRODUCT_API}/v3`, data);
};

ProductService.updateProductV3 = function (data) {
  return axiosInstance.put(`${PRODUCT_API}/v3`, data);
};

ProductService.updateVariantV2 = function (data) {
  return axiosInstance.put(PRODUCT_UPDATE_VARIANT_V2, data);
}

ProductService.syncProductPartner = function (data) {
  return axiosInstance.post(SYNC_PRODUCT_PARTNER, data);
}

ProductService.applyOtherOption = function (data) {
  return axiosInstance.post(APPLY_OTHER_OPTION, data);
}

ProductService.applyAdditionOption = function (data) {
  return axiosInstance.post(APPLY_ADDITION_OPTION, data);
}

//UNIT BY PARTNER
ProductService.getAllUnit = function (partnerId) {
  return axiosInstance.get(`${PARTNER_UNIT}/${partnerId}`, null);
};

ProductService.upsertUnit = function (data) {
  return axiosInstance.post(PARTNER_UNIT, data);
}

ProductService.deleteUnit = function (id) {
  return axiosInstance.delete(`${PARTNER_UNIT}/${id}`, null);
};

export default ProductService;
